import {  Form, Input } from "antd";
import React from "react";

const TitleField=({disable})=> {
    return (
        <React.Fragment>
            <Form.Item
                name="title"
                rules={[{ required: true, message: "Champ obligatoire" }]}
            >
                <Input size='medium' placeholder='Titre' disabled={disable} addonBefore={"Titre :"}/>
            </Form.Item>
        </React.Fragment>
    )
}

export default TitleField;